// extracted by mini-css-extract-plugin
export var link = "link-module--link--NcxZW";
export var linkArrow = "link-module--linkArrow--4ygRB";
export var linkArrowMedium = "link-module--linkArrowMedium--wELO0";
export var linkArrowFill = "link-module--linkArrowFill--006VJ";
export var linkEmail = "link-module--linkEmail--OQKGp";
export var linkEmailArrow = "link-module--linkEmailArrow--r1Giz";
export var linkEmailArrowMedium = "link-module--linkEmailArrowMedium--9E-7s";